import { __assign } from "tslib";
import { createLinesApi } from './lines';
import { createQueuesApi } from './queues/';
import { createCallsApi } from './calls';
import { createIvrsApi } from './ivrs';
import { createCallCenterInsightsApi } from './insights';
export * from './insights';
export * from './queues';
export * from './calls';
export * from './ivrs';
export * from './lines';
export var buildStatsFilterFromDto = function (dto) {
    var filter = '';
    if (dto.queueId) {
        filter = "?queueId=" + dto.queueId;
    }
    else if (dto.locale) {
        filter = "?locale=" + dto.locale;
    }
    else if (dto.location) {
        filter = "?location=" + dto.location;
    }
    else if (dto.groupId) {
        filter = "?groupId=" + dto.groupId;
    }
    else if (dto.sortType) {
        filter = "?sortType=" + dto.sortType;
    }
    return filter;
};
export var createCallcenterApi = function (baseUrl, http) {
    var url = baseUrl + "/callcenter";
    return {
        updateQueuesPriorities: function (dto) {
            return http.put(url + "/agents/" + dto.userId + "/queues/priorities", dto);
        },
        getAgent: function (id) {
            return http.get(url + "/agents/" + id);
        },
        getDashboardStats: function (dto) {
            return http.post(url + "/stats", dto);
        },
        getStats: function (dto) {
            var filter = buildStatsFilterFromDto(dto);
            return http.get(url + "/stats" + filter);
        },
        getQueuesStats: function (dto) {
            var filter = buildStatsFilterFromDto(__assign({}, dto));
            return http.get(url + "/stats/queues" + filter);
        },
        searchAgents: function (dto) {
            var temp = dto;
            if (dto.callCenterAgentSortType) { // TODO: remove this
                temp.sortType = dto.callCenterAgentSortType;
            }
            return http.post(url + "/agents/search", temp);
        },
        addAgent: function (dto) {
            return http.post(baseUrl + "/agents/" + dto.id + "/callcenter", {});
        },
        removeAgent: function (dto) {
            return http.delete(baseUrl + "/agents/" + dto.id + "/callcenter");
        },
        getCurrentAgent: function () {
            return http.get(url + "/agents/me");
        },
        setCallCenterActivity: function (dto) {
            return http.post(url + "/agents/activity", dto);
        },
        setAgentsStatus: function (dto) {
            return http.post(url + "/agents/activity/admin", dto);
        },
        syncAgent: function (userId) {
            return http.post(url + "/agents/sync", { userId: userId });
        },
        startShift: function () { return http.post(url + "/agents/start-shift", {}); },
        endShift: function () { return http.post(url + "/agents/end-shift", {}); },
        calls: createCallsApi(url, http),
        getWorkerToken: function (ttlSeconds) {
            var query = ttlSeconds ? "?ttlSeconds=" + ttlSeconds : '';
            return http.get(url + "/agents/worker-token" + query);
        },
        verifyCallCenter: function (dto) {
            return http.post("https://app.wixanswers.com/adminApi/cc-verification", dto);
        },
        enableAgentExtendedTimeout: function (dto) {
            return http.post(url + "/agents/" + dto.id + "/extendCallbackReservationTimeout/enable", {});
        },
        disableAgentExtendedTimeout: function (dto) {
            return http.post(url + "/agents/" + dto.id + "/extendCallbackReservationTimeout/disable", {});
        },
        updateAgentsQueueAssignments: function (dto) {
            return http.post(url + "/agents/queues", dto);
        },
        queues: createQueuesApi(url, http),
        ivrs: createIvrsApi(url, http),
        lines: createLinesApi(url, http),
        insights: createCallCenterInsightsApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map